
export const driverForm = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  password: "",
  driver_license: "",
};

export const fixedRouteObj = {
  origin: "",
  destination: "",
  origin_lat: 0,
  origin_lon: 0,
  destination_lat: 0,
  destination_lon: 0,
  price: 0,
};

export const inventoryForm = {
  name: "",
  sku: "",
  category: "",
  price: "",
  quantity: "",
  supplier_id: "",
  min_stock_level: "",
  warranty_months: "",
  unit: "",
  description: "",
};

export const branchForm = {
  name: "",
  address: "",
  phone: "",
  opening_hours: "",
  email: "",
  description: "",
};

export const serviceForm = {
  title: "",
  total_cost: "",
  warranty_price: "",
  warranty_unit: "",
  notes: ""
};

export const clientForm = {
  name: "",
  email: "",
  phone: "",
};

export const vehicleForm = {
  make: "",
  model: "",
  vin: "",
  license_plate: "",
  year: ""
};

export const userRoleForm = {
  name: "",
  email: "",
  contact: "",
  address: "",
  role: "",
  password: "",
};

export const reservationForm = {
  ...clientForm,
  ...vehicleForm,
  date: "",
  time: "",
  status: "PENDING",
  notes: "",
  technician_id: 0,
  branch_id: 0,
  reservation_items: []
};

export const invoiceForm = {
  ...clientForm,
  ...vehicleForm,
  date: "",
  time: "",
  total: 0,
  payment: "",
  notes: "",
  invoice_items: [],
};

export const vendorForm = {
  vendor_name: "",
  notes: "",
};

export const expenseAndService = {
    time: "",
    odometer: 0,
    notes: "",
    date: new Date(),
    vehicle_id: 0,
}

export const reservationRequiredFields = [
  "name",
  "email",
  "contact",
  "address",
  "vin",
  "make",
  "model",
  "year",
  "branch",
  "date",
  "time",
];
